import React from "react";
import Comingsoonpage from "../../../common/Comingsoon";

const WholesaleBillOfSale = () => {
  return (
    <div>
      <Comingsoonpage />
    </div>
  );
};

export default WholesaleBillOfSale;
